export const theme = {
  fonts: {
    text: 'Ubuntu, sans-serif',
  },
  colors: {
    white: '#ffffff',
    blue: '#0057b6',
    blueDark: '#014896',
    gray: '#7B7B7B',
    grayLight: '#dadada',
    red: '#a50000',
    green: '#3F9D23',
    greenLight: '#BCE7AF',
    purple: '#912A81',
    purpleDark: '#590b54',
    black: '#000000',
    transparent: 'transparent',
  },
  outline: '3px solid #000',
}
